import en from './en.json'
import ja from './ja.json'
import zh from './zh.json'
import ko from './ko.json'

export const defaultLocale = 'ja'

export const languages = {
  en: en,
  ja: ja,
  zh: zh,
  ko: ko,
}

export const localeHelper = function(lang) {
  let locale = lang
  if(lang === 'zh') {
    locale = 'zh-hans'
  }
  return locale
}